import * as React from "react"
import { File } from "types/download-center"
import { Tr, Td } from "react-super-responsive-table"
import { DownloadButton, Typography, Picture } from "components"
import { toPersianDigits } from "utils"

const DownloadItem: React.FC<File> = ({
	image,
	name_en,
	name_fa,
	dc32,
	dc64,
	dl32,
	dl64,
	os,
	size,
	version,
}) => {
	return (
		<Tr>
			<Td className="download-center__item">
				<Picture src={image} alt={name_en} />
			</Td>
			<Td>
				<Typography gutterBottom paragraph>
					{name_en}
				</Typography>
				<Typography gutterBottom paragraph>
					{name_fa}
				</Typography>
			</Td>
			<Td>{toPersianDigits(version)}</Td>
			<Td>{os}</Td>
			<Td>{toPersianDigits(size)}</Td>
			<Td>
				<DownloadButton link32={dl32} link64={dl64} />
			</Td>
			<Td>
				<DownloadButton link32={dc32} link64={dc64} />
			</Td>
		</Tr>
	)
}

export default DownloadItem
